import { toDateString } from "@legacy-megarax/common";
import { workDayResource } from "@legacy-megarax/crm-contracts";
import { useResourceProviderV2 } from "@legacy-megarax/react-client";
import { useQueries, useQuery } from "react-query";

export const useWorkWeekDays = (dates: Date[], userId: number) => {
  const workDayProvider = useResourceProviderV2(workDayResource);

  const queries = useQueries(
    dates.map((date) => ({
      queryKey: ["userWorkDay", date, userId],
      queryFn: () =>
        workDayProvider
          .byUserId(userId!)
          .byDate(toDateString(date))
          .retrieve()
          .then((r) => r.assertOk().value),
    })),
  );

  return {
    workDays: queries.map((q) => q.data),
    isLoading: queries.some((q) => q.isFetching),
    refetch: () => queries.forEach((q) => q.refetch()),
  };
};
